export default __webpack_public_path__ + "static/media/y.c14a2344.mp4";